/**
 * @generated SignedSource<<463e17c4e31cb626056c4851d77e7fef>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WATeamScheduleSettingsQuery$variables = Record<PropertyKey, never>;
export type WATeamScheduleSettingsQuery$data = {
  readonly store: {
    readonly publicTeams: ReadonlyArray<{
      readonly id: string;
      readonly name: string;
      readonly roles: ReadonlyArray<{
        readonly id: string;
        readonly name: string;
      }>;
      readonly " $fragmentSpreads": FragmentRefs<"TeamIconCircleComponent_Team" | "WATeamScheduleSettings_teamDialog">;
    }>;
  };
};
export type WATeamScheduleSettingsQuery = {
  response: WATeamScheduleSettingsQuery$data;
  variables: WATeamScheduleSettingsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "concreteType": "EmployeeRole",
  "kind": "LinkedField",
  "name": "roles",
  "plural": true,
  "selections": [
    (v0/*: any*/),
    (v1/*: any*/)
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "WATeamScheduleSettingsQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Store",
        "kind": "LinkedField",
        "name": "store",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Team",
            "kind": "LinkedField",
            "name": "publicTeams",
            "plural": true,
            "selections": [
              (v0/*: any*/),
              (v1/*: any*/),
              (v2/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "TeamIconCircleComponent_Team"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "WATeamScheduleSettings_teamDialog"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "WATeamScheduleSettingsQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Store",
        "kind": "LinkedField",
        "name": "store",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Team",
            "kind": "LinkedField",
            "name": "publicTeams",
            "plural": true,
            "selections": [
              (v0/*: any*/),
              (v1/*: any*/),
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "color",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "icon",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isPrivate",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v0/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "602d16aab02ef24b26f6e69b6faea6a3",
    "id": null,
    "metadata": {},
    "name": "WATeamScheduleSettingsQuery",
    "operationKind": "query",
    "text": "query WATeamScheduleSettingsQuery {\n  store {\n    publicTeams {\n      id\n      name\n      roles {\n        id\n        name\n      }\n      ...TeamIconCircleComponent_Team\n      ...WATeamScheduleSettings_teamDialog\n    }\n    id\n  }\n}\n\nfragment TeamIconCircleComponent_Team on Team {\n  color\n  icon\n  isPrivate\n}\n\nfragment WATeamScheduleSettings_teamDialog on Team {\n  id\n  name\n  isPrivate\n  ...TeamIconCircleComponent_Team\n}\n"
  }
};
})();

(node as any).hash = "a68b0f9926395d680290cc277cd3d272";

export default node;
